const herocomment = {
    getlist: 'herocomment/getlist-by-admin',
    add: 'herocomment/add-by-admin',
    update: 'herocomment/update',
    remove: 'herocomment/remove',
}
export default herocomment
